module.exports = __webpack_public_path__ + "sunsemweb/img/o1.65d5c2f0.png";